import React from 'react'
import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { SelectField } from 'shared/ui/Select/SelectField/SelectField'
import { Icon, type IDropdownItem, type IIconsVector } from 'shared/ui'
import icons from 'shared/ui/Icon/icons'
import { type IntegrationSyncType } from 'pages/settings/pages/integrations/pages/integrationSettings/lib'
import styles from './styles.module.scss'

type IIntegrationSyncDropdownProps = {
  syncType: IntegrationSyncType
  setSyncType: (v: IntegrationSyncType) => void
  isTwoWaySync: boolean
  selectItems: IDropdownItem[]
  integrationIcon: IIconsVector
  iconHeight?: number
}

export const IntegrationSyncDropdown: React.FC<IIntegrationSyncDropdownProps> = observer(
  ({ isTwoWaySync, setSyncType, syncType, selectItems, integrationIcon, iconHeight = 98 }) => {
    const iconStyle: Record<string, string> = {
      '--svg-height': `${iconHeight}px`,
    }
    return (
      <div className={styles.root}>
        <div
          className={classNames(styles.integrationIcon, styles.integrationIconCustom)}
          style={iconStyle}
        >
          {icons[integrationIcon]}
        </div>
        <div className={styles.typeIcon}>
          <Icon
            fontSize={16}
            icon={isTwoWaySync ? 'arrowHorizontalOutline' : 'arrowRight'}
            tertiary
          />
        </div>
        <div className={styles.integrationIcon}>
          <Icon fontSize={114} icon={'integrationSalessms'} tertiary />
        </div>
        <SelectField
          className={styles.select}
          withSearch={false}
          value={syncType}
          setValue={setSyncType}
          items={selectItems}
          size={'medium'}
        />
      </div>
    )
  }
)
